export interface ModelTarget { framework: string; dataset: string; }

export const MODEL_TARGETS = [
  { framework: 'CP2015', dataset: 'calibration_2017_40c', label: 'CP2015' },
  { framework: 'Furusawa2023', dataset: 'calibration_2017_40c', label: 'Furusawa2023' },
  { framework: 'CP2015', dataset: 'exiobase2023_45c_200s', label: 'CP2015' },
];
export const DATASETS = [
  { id: 'calibration_2017_40c', label: 'Eora 2017 · 40 countries · 23 sectors' },
  { id: 'exiobase2023_45c_200s', label: 'EXIOBASE 2023 · 45 regions · 200 products' },
];
export const datasetLabel = (dataset: string) => DATASETS.find(d => d.id === dataset)?.label || dataset;
export const modelLabel = (framework: string) => MODEL_TARGETS.find(t => t.framework === framework)?.label || framework;
